export let SelectUtility = {
    selectOptionForId: function (id, options) {
        return (options || []).find((option) => '' + option.value === '' + id)
    },

    modelArrayToSelectOptions: function (modelArray, valueProperty, labelProperty, labelFunction) {
        return (modelArray || []).map(function (model) {
            let label
            if (labelFunction) {
                label = labelFunction(model)
            } else {
                label = model[labelProperty || 'name'];
            }
            return {
                value: model[valueProperty || 'id'],
                label: label
            }
        })
    }
}
